import Pristine from 'pristinejs';

// Listen to when Google Places API is loaded and throw an event so that our Alpine script can do what it needs to do.
window.findMyMPPlacesInit = function () {
	document.dispatchEvent(new Event('find-my-mp:places:ready'));
};

Alpine.data('findMyMP', (type) => {
	let autocomplete;
	let timeout;

	const pristineConfig = {
		classTo: 'gfield',
		errorClass: 'gfield_error',
		successClass: 'gfield_success',
		errorTextParent: 'gfield',
		errorTextTag: 'div',
		errorTextClass: 'gfield_validation_message',
	};

	return {
		query: '',
		loading: false,
		error: null,
		results: [],
		type,
		address: {
			suburb: null,
			postcode: null,
			state: null,
		},

		init() {
			document.addEventListener('find-my-mp:places:ready', () => {
				this.initAddressPlacesAutocomplete();
			});

			document.dispatchEvent(new Event('find-my-mp:places:ready'));
		},
		initAddressPlacesAutocomplete() {
			autocomplete = new google.maps.places.Autocomplete(this.$refs.address, {
				componentRestrictions: { country: 'au' },
				fields: ['address_components', 'geometry'],
				types: ['sublocality', 'locality', 'neighborhood', 'postal_code'],
			});

			// Populate the 'address' object based on the Google Places
			google.maps.event.addListener(autocomplete, 'place_changed', () => {
				const place = autocomplete.getPlace();

				// Reset the address data.
				this.address = {
					suburb: null,
					postcode: null,
					state: null,
				};

				place.address_components &&
					place.address_components.forEach((component) => {
						if (component.types.includes('postal_code')) {
							this.address.postcode = component.long_name;
						}
						if (component.types.includes('administrative_area_level_1')) {
							this.address.state = component.short_name;
						}
						if (component.types.includes('locality')) {
							this.address.suburb = component.long_name;
						}
					});
			});
		},
		handleSubmit() {
			clearTimeout(timeout);

			// Debounce the submit event, allowing for Google Places to generate the address components.
			timeout = setTimeout(() => {
				const validator = new Pristine(this.$refs.form, pristineConfig);
				let valid = validator.validate();

				// Custom validation if the user hasn't selected an address from the Gooogle Places dropdown.
				if (
					!this.address.state ||
					!this.address.suburb ||
					!this.address.postcode
				) {
					validator.addError(
						this.$refs.address,
						'Please select a suburb from the dropdown.'
					);

					valid = false;
				}

				if (valid) {
					this.sendRequest();
				}
			}, 500);
		},
		sendRequest() {
			this.loading = true;
			this.error = null;
			this.results = [];

			this.$store.aa
				.api('electorates')
				.post({
					type: this.type,
					...this.address,
				})
				.json((response) => {
					if (response.success) {
						const electorates = response?.data?.electorates || [];

						const results = [];
						electorates?.length &&
							electorates.forEach((electorate) => {
								results.push({
									id: electorate.id,
									name: electorate.mp_name,
									role: `${electorate.party} Member for ${electorate.name}`,
									address: electorate.address || '',
									phone: electorate.phone,
									email: electorate.email,
								});
							});

						this.results = results;

						this.loading = false;

						this.$store.aa.track({
							event: 'find_my_mp',
							data: {
								...this.address,
								...(response.data || {}),
							},
						});
					} else {
						this.error = response.message || null;
					}
				})
				.catch((response) => {
					this.error = response?.json?.message || response?.message;
				});
		},
	};
});
